var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Asesor")]),_c('th',[_vm._v("Solicitudes a propuesta aceptada")]),_c('th',[_vm._v("Propuesta aceptada a file comercial")]),_c('th',[_vm._v("Aprobados a cliente")]),_c('th',[_vm._v("Solicitudes a file comercial")]),_c('th',[_vm._v("Solicitudes a aprobados")]),_c('th',[_vm._v("Solicitudes a clientes")])])])
}]

export { render, staticRenderFns }